module.exports = __webpack_public_path__ + "static/media/bg-login.20b8dfe2.jpg";